// Module
var code = "<span><img ng-if=iconSource src={{iconSource}} id=itemImg></span>";
// Exports
module.exports = code;